import { handleAxiosError } from "../common/handleAxiosError";
import { IFormData, ITaskUpdatedResponse } from "./types";
import { apiClientSource } from "../common/axiosInstanceSource";

interface IUpdateTask {
  taskId: string;
  task: IFormData;
}

export const updateTask = async ({ taskId, task }: IUpdateTask): Promise<ITaskUpdatedResponse> => {
  try {
    const response = await apiClientSource.put(`/task-service/api/tasks/${taskId}`, task);
    return response?.data;
  } catch (error) {
    handleAxiosError(error, "Error al actualizar la tarea");
    throw error;
  }
};
